import './Banner.css'

const Banner = () => {
    return (
        <header className="banner">
            <img src="/imagens/banner.png" alt="Banner principal da página do organo"/>
        </header>
    )
}

export default Banner;